import NavigationBar from "../../components/NavigationBar";
import styles from "../styles/LoginHeader.module.scss";

export default function LoginHeader() {
  return (
    <div className={styles.main}>
      <div className={styles.background}>
        <NavigationBar></NavigationBar>
      </div>
    </div>
  );
}
